import * as React from 'react';

import Rocket16 from './Rocket16';

export const rocket16 = () => <Rocket16 />;

export default {
    title: 'Icon/Line/Rocket16',
    component: Rocket16,
    parameters: {
        notes: "`import Rocket16 from 'box-ui-elements/es/icon/line/Rocket16';`",
    },
};
